import { Component, OnInit } from '@angular/core';
import { ModalOptionsConfig, ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { RegisterBiometricComponent } from '../login/partials/register-biometric/register-biometric.component';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { LoginHelperService } from '@mpt-fo/common/core/services/login-helper.service';
import { BusinessOperationModeLoaderComponent } from '../../../post-login-operations/selection-operation-mode/partials/business-operation-mode/partials/business-operation-mode-loader/business-operation-mode-loader.component';

@Component({
	selector: 'app-biometric',
	templateUrl: './biometric.component.html',
	styleUrls: ['./biometric.component.scss'],
})
export class BiometricComponent implements OnInit {
	runningModal: NzModalRef;

	constructor(private modalService: ModalService, private loginHelper: LoginHelperService) {}

	ngOnInit(): void {}

	continue() {
		this.openBiometricRegistrationModal();
	}

	openBiometricRegistrationModal() {
		const config = this.createModalBiometricConfig();
		this.runningModal = this.modalService.createModal(RegisterBiometricComponent, config);
	}

	handleCloseModal() {
		this.cancel();
	}

	cancel(ignoreBiometric = false) {
		if (ignoreBiometric) {
			this.openLoader();
		}
		this.loginHelper.navigateSignInUser(null, ignoreBiometric);
	}

	openLoader() {
		this.launchModal(BusinessOperationModeLoaderComponent);
	}

	launchModal(component) {
		const config = this.createModalConfig();
		this.runningModal = this.modalService.createModal(component, config);
	}

	createModalConfig() {
		const config = new ModalOptionsConfig();
		config.className = 'hide-ant-modal';
		config.nzComponentParams.callback = (param) => {};
		return config;
	}

	closeModal() {
		try {
			this.runningModal.destroy();
		} catch (error) {}
	}

	private createModalBiometricConfig() {
		const config = new ModalOptionsConfig();
		config.className = 'moniepoint-dialog';
		config.nzComponentParams.callback = () => {
			this.handleCloseModal();
		};
		return config;
	}
}
